module.exports = __webpack_public_path__ + "static/media/a.dc1dcab0.jpg";